/**
 *
 * @author Russell Lilljedahl
 * @prettier
 *
 * @since 23.6
 *
 * */
import React from 'react'
import LGYMessageImage from './LGYMessageImage'
/**
 * Image link to the CSM chatbot and logged in submit help button
 *
 * @property {string} hyperlink - Hyperlink to the CSM chatbot and submit help function
 *
 */

const SubmitHelp = ({ hyperlink }) => (
  <div>
    Want to contact us? No problem
    <a className='usa-button submit-help-ticket-link' href={hyperlink} target='_blank' rel='noopener noreferrer'>
      Submit a help ticket
    </a>
    <LGYMessageImage link={hyperlink}></LGYMessageImage>
  </div>
)

export default SubmitHelp
